module.exports = __webpack_public_path__ + "static/media/more_new.e28f1994.svg";